/* ClickCollectRetailer Vue Router Routes */
const clickcollectretailers = [
  {
    path: '/clickcollectretailers',
    name: 'clickcollectretailer-list',
    component: () => import('@/views/clickcollectretailer/ClickCollectRetailerList.vue'),
    meta: {
      layout: 'content',
      resource: 'Administration',
      action: 'read'
    },
  },
  {
    path: '/clickcollectretailers/create',
    name: 'clickcollectretailer-create',
    component: () => import('@/views/clickcollectretailer/ClickCollectRetailerCreate.vue'),
    meta: {
      layout: 'content',
            resource: 'Administration',
      action: 'read'
    },
  },
  {
    path: '/clickcollectretailers/:id',
    name: 'clickcollectretailer-view',
    component: () => import('@/views/clickcollectretailer/ClickCollectRetailerView.vue'),
    props: true,
    meta: {
      layout: 'content',
            resource: 'Administration',
      action: 'read'
    },
  },
  {
    path: '/clickcollectretailers/edit/:id',
    name: 'clickcollectretailer-edit',
    component: () => import('@/views/clickcollectretailer/ClickCollectRetailerEdit.vue'),
    props: true,
    meta: {
      layout: 'content',
            resource: 'Administration',
      action: 'read'
    },
  },
]

export default clickcollectretailers
